import clsx from 'clsx';
import Link from 'next/link';

type Props = {
  popularBrandsData: { id: number; name: string; slug: string; smallCategorySlug: string }[];
  activeBrandId: number;
  handleClick: (brandId: number) => void;
  title: string;
};

export const Presenter: React.FC<Props> = ({ activeBrandId, handleClick, title, popularBrandsData }) => (
  <div className="pb-2 text-darkSlate text-sm border-b border-solid border-gray500">
    <div className="scrollable-container">
      <div className="px-3 py-1 font-bold whitespace-nowrap">{title}</div>
      {popularBrandsData.map((brand) => (
        <Link key={brand.id} href={`/small_categories/${brand.smallCategorySlug}?brand=${brand.slug}`}>
          <a
            className={clsx(
              'px-3 py-1 whitespace-nowrap cursor-pointer',
              brand.id === activeBrandId ? 'text-primary' : ''
            )}
            onClick={() => {
              handleClick(brand.id);
            }}
          >
            #{brand.name}
          </a>
        </Link>
      ))}
    </div>
  </div>
);
